const CommonContentComponent = () => import('@/views/kpi/CommonContent/CommonContentView')

export default [
    {
        path:'/CommonContentIndex',
        name:'CommonContentComponent',
        component:CommonContentComponent
    }
]